import routerOptions0 from "/home/nuxt-builder/builds/eeb546d8c70a-20261102-165820-232715/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}